import { t } from 'i18next';
import { useTelegramBackButton } from '../../../utils/BackButton';

import { Button } from '../../../components/ui/button';
import { PlusIcon } from '../../../assets/Plus';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerTrigger,
} from '../../../components/ui/drawer';

import { useGetCardList } from '../services/getAll';
import { Loader2 } from 'lucide-react';
import { RadioGroup, RadioGroupItem } from '../../../components/ui/radio-group';
import { Card } from '../../../components/ui/card';
import { Separator } from '../../../components/ui/separator';
import { DeleteAddressesIcon } from '../../../assets/DeleteAdresses';
import { useState } from 'react';
import { useDeleteCard } from '../services/delete';

import { cardImg } from '../libs/cardImg';
import { SavaeCardDrawer } from '../../../components/SaveCardDrawer';

export const UserCard = () => {
  const savedCard = localStorage.getItem('savedCard');

  const [userSavedCard, setUserSavedCard] = useState(savedCard);
  useTelegramBackButton('/profile');

  const [drawerOpen, setDrawerOpen] = useState(false);
  const { cardList, isLoading } = useGetCardList();
  const { deleteCard, isPending: isPendingDelete } = useDeleteCard();

  const handleDelete = async (id: number) => {
    await deleteCard(id);
  };

  if (isLoading) {
    return (
      <div className="h-full flex items-center justify-center">
        <Loader2 className="h-10 w-10 animate-spin" />
      </div>
    );
  }

  return (
    <div className="flex flex-col px-4 pt-4 pb-2 min-h-full">
      <div className="space-y-4">
        {cardList.length > 0 && (
          <p className="text-display-sm flex w-full  justify-center text-center">
            {t('card')}
          </p>
        )}
        <div className="flex flex-col space-y-4">
          {cardList.length > 0 ? (
            <RadioGroup>
              <Card className="pt-[9px] rounded-xl space-y-2 w-full ">
                <div className="h-[99%] overflow-y-auto w-full">
                  {cardList.map((card, index) => (
                    <div className="flex flex-col w-full space-y-[9px] ">
                      <div className="flex flex-row w-full justify-between pl-[18px] pr-[9px]  items-center max-h-[400px]">
                        <div
                          className="flex flex-row items-center space-x-[18px] w-full "
                          onClick={e => {
                            localStorage.setItem(
                              'savedCard',
                              card.id.toString()
                            );
                            setUserSavedCard(card.id.toString());
                            e.stopPropagation();
                          }}
                        >
                          <RadioGroupItem
                            isCircular
                            value={card.id.toString()}
                            checked={Number(card.id) === Number(userSavedCard)}
                          />
                          <div className="flex flex-row items-center space-x-2  w-full p-1">
                            <img
                              src={cardImg(card.ps)}
                              alt="card"
                              className="w-12 h-[30px] object-cover border border-border-tertiary rounded-[4px]"
                            />
                            <p className="text-body-base-regular text-text-primary">{`******${card.last_numbers}`}</p>
                          </div>
                        </div>
                        <div className="flex flex-row space-x-2 items-center">
                          <Drawer>
                            <DrawerTrigger asChild>
                              <button type="button">
                                <DeleteAddressesIcon className="text-text-icon-tertiary" />
                              </button>
                            </DrawerTrigger>
                            <DrawerContent>
                              <div className="px-4 pb-4 flex flex-col space-y-2">
                                <div className="flex flex-row items-center justify-between">
                                  <p className="text-display-md max-w-[311px]">
                                    {t('delete-card')}
                                  </p>
                                </div>

                                <p className="text-body-sm-regular text-text-tertiary">
                                  {t('delete-card-description')}
                                  ****{card.last_numbers}
                                </p>
                                <div className="flex flex-col space-y-2 py-4">
                                  <Button
                                    className="h-12 bg-button-primary flex flex-row items-center justify-center rounded-xl shadow-none w-full"
                                    disabled={isPendingDelete}
                                    onClick={() => handleDelete(card.id)}
                                  >
                                    <p className="text-display-sm ">
                                      {t('accept')}
                                    </p>
                                  </Button>
                                  <DrawerClose asChild>
                                    <Button className="h-12 bg-button-secondary flex flex-row items-center justify-center rounded-xl w-full shadow-none">
                                      <p className="text-display-sm text-text-primary">
                                        {t('cancel')}
                                      </p>
                                    </Button>
                                  </DrawerClose>
                                </div>
                              </div>
                            </DrawerContent>
                          </Drawer>
                        </div>
                      </div>
                      <div className="pl-28">
                        {index !== cardList.length - 1 && (
                          <Separator className="w-full" />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            </RadioGroup>
          ) : (
            <div className="flex flex-col h-full  items-center justify-center  space-y-1 text-center">
              <p className="text-body-base-medium text-text-secondary">
                {t('no-card')}
              </p>
              <p className="text-body-sm-regular text-text-secondary ">
                {t('no-card-description')}
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="mt-auto w-full pt-4">
        <Button
          onClick={() => {
            setDrawerOpen(true);
          }}
          className="h-12 bg-brand-green rounded-xl flex flex-row items-center justify-center w-full"
        >
          <PlusIcon className="text-text-white mr-2" />
          <p className="text-text-white text-display-sm">{t('add-card')}</p>
        </Button>
      </div>
      <SavaeCardDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
    </div>
  );
};

export default UserCard;
